import MDinput from '@/components/MDinput';
import Select from '@/components/DSE/Select';
import Switch from '@/components/DSE/Switch';
import { validatorEAN, validatorRequire, validatorConditionalRequired } from '@/utils/validators';
import InputNumber from '@/components/DSE/InputNumber';
import RadioGroupInput from '@/components/DSE/RadioGroupInput';

export function getFormDefinition(vue) {
  return {
    description: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 64
      },
      rules: [{ validator: validatorRequire }]
    },
    ean: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 13
      },
      rules: [{ validator: validatorEAN }]
    },
    measurementInMm: {
      type: InputNumber,
      defaultValue: null,
      valueOnFormChange: (form, oldValue) => {
        if (!vue.measurementIsRequired()) {
          return null;
        }
        return oldValue;
      },
      dynamicProps: form => ({
        visible: vue.measurementIsRequired()
      }),
      props: {
        caption: 'product.measurementInMm'
      },
      dynamicRules: form => [{ validator: validatorConditionalRequired(vue.measurementIsRequired()) }]
    },
    ownProductYN: {
      type: Switch,
      defaultValue: true,
      props: {
        caption: 'product.ownProduct',
        activeText: 'common.yes',
        inactiveText: 'common.no'
      }
    },
    ownCode: {
      type: MDinput,
      defaultValue: null,
      props: {
        maxlength: 32,
        caption: 'product.ownCode'
      }
    },
    domainID: {
      type: Select,
      defaultValue: null,
      valueOnFormChange: (form, oldValue) => {
        if (form.ownProductYN) {
          return null;
        }
        return oldValue || vue.$store.getters['domain/getDefaultSelectValueDomainID'];
      },
      dynamicProps: form => ({
        visible: !form.ownProductYN
      }),
      props: {
        caption: 'common.domain',
        required: true,
        valueField: 'id',
        labelField: 'name',
        options: vue.$store.getters.domains
      }
    },
    domainProductCode: {
      type: MDinput,
      defaultValue: '',
      valueOnFormChange: (form, oldValue) => {
        if (form.ownProductYN) {
          return null;
        }
        return oldValue;
      },
      dynamicProps: form => ({
        visible: !form.ownProductYN
      }),
      props: {
        maxlength: 32,
        caption: 'domain.domainCode'
      }
    },
    vatTypeID: {
      type: RadioGroupInput,
      defaultValue: null,
      props: {
        caption: 'vat.vatType',
        valueField: 'id',
        labelField: 'name',
        loading: vue.$store.getters['vatType/isLoading'],
        options: vue.vatTypes
      }
    },
    printOnTicketYN: {
      type: Switch,
      defaultValue: false,
      props: {
        caption: 'product.printOnTicket',
        activeText: 'common.yes',
        inactiveText: 'common.no'
      }
    },
    inactiveYN: {
      type: Switch,
      defaultValue: false,
      props: {
        caption: 'common.inactive',
        activeText: 'common.yes',
        inactiveText: 'common.no'
      }
    }
  };
}

export function createItemFromFormData(vue, form) {
  const item = { ...form };
  if (form.ownCode === '') {
    item.ownCode = null;
  }
  return item;
}

export function createFormDataFromItem(vue, item) {
  return item;
}
